import actionCreatorFactory from 'typescript-fsa';
import { UserSong } from '../../../services/playlist';

const actionCreator = actionCreatorFactory();

export const MY_PLAYLIST_LOAD = 'MY_PLAYLIST_LOAD';
export const myPlaylistLoad = actionCreator(MY_PLAYLIST_LOAD);

export const MY_PLAYLIST_SET = 'MY_PLAYLIST_SET';
export const myPlaylistSet = actionCreator<UserSong[]>(MY_PLAYLIST_SET);

export const MY_PLAYLIST_DELETE_SONG = 'MY_PLAYLIST_DELETE_SONG';
export const myPlaylistDeleteSong = actionCreator<string>(MY_PLAYLIST_DELETE_SONG);

export const MY_PLAYLIST_VOTE = 'MY_PLAYLIST_VOTE';
export const myPlaylistVote = actionCreator<{songId: string, vote: number}>(MY_PLAYLIST_VOTE);

export const MY_PLAYLIST_UPDATE_VISIBILITY = 'MY_PLAYLIST_UPDATE_VISIBILITY';
export const myPlaylistUpdateVisibility = actionCreator<boolean>(MY_PLAYLIST_UPDATE_VISIBILITY);

export const MY_PLAYLIST_SET_VISIBILITY = 'MY_PLAYLIST_SET_VISIBILITY';
export const myPlaylistSetVisibility = actionCreator<boolean>(MY_PLAYLIST_SET_VISIBILITY);
